import { ButtonTheme, ButtonType } from '@ui-components/PlayButton';
import PlayText from '@ui-components/typography/PlayText';
import { UserSurveyFragment } from 'app/graphql/__generated__/types/contento';
import React, { useState } from 'react';
import {
    Button,
    ButtonWrapper,
    CustomRadio,
    Form,
    Heading,
    Input,
    InputWrapper,
    Label,
    Legend,
    LegendWrapper,
    StyledRange,
} from '../UsabilityTest.styles';

type Props = {
    onClick: (value: number) => void;
    onCloseSurvey: (value: string) => void;
    survey: UserSurveyFragment;
};

const Experienced = ({ onClick, survey, onCloseSurvey }: Props) => {
    const [difficulty, setDifficulty] = useState(null);

    const onValueChange = (value: number) => {
        setDifficulty(value);
    };

    const getInputs = () => {
        const inputs = [];

        for (let i = 1; i <= 7; i++) {
            inputs.push(
                <Label key={`experienced-input-${i}`}>
                    {i}
                    <Input
                        checked={difficulty === i}
                        type="radio"
                        value={i}
                        onChange={() => onValueChange(i)}
                    />
                    <CustomRadio />
                </Label>
            );
        }

        return inputs;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onClick(difficulty);
        setDifficulty(null);
    };

    return (
        <>
            <Heading>Bra jobbat, nu är du nästan klar</Heading>
            <PlayText>Hur lätt eller svårt var det att att utföra uppgiften?</PlayText>

            <Form onSubmit={handleSubmit}>
                <InputWrapper>{getInputs()}</InputWrapper>

                <StyledRange />
                <LegendWrapper>
                    <Legend>Mycket svårt</Legend>
                    <Legend>Mycket lätt</Legend>
                </LegendWrapper>

                <ButtonWrapper>
                    <Button
                        buttonType={ButtonType.BUTTON}
                        theme={ButtonTheme.DEFAULT}
                        type="button"
                        onClick={() => {
                            onCloseSurvey(survey.id);
                        }}
                        cancel
                    >
                        Avbryt
                    </Button>
                    <Button
                        isDisabled={difficulty === null}
                        buttonType={ButtonType.BUTTON}
                        theme={ButtonTheme.WHITE}
                        type="submit"
                    >
                        Avsluta testet
                    </Button>
                </ButtonWrapper>
            </Form>
        </>
    );
};

export default Experienced;
